/**
 * App build version — embedded at build time.
 * Bump this with each native release so we can track
 * which version drivers are running via page_view_logs.
 */
 export const APP_VERSION = "1.82";

/**
 * iOS build number (CURRENT_PROJECT_VERSION) this web bundle is released as.
 * Must equal the native build number of the archive it is embedded in —
 * `scripts/verify-release-integrity.mjs` fails the archive otherwise.
 */
export const IOS_BUILD = "190";

/**
 * Literal, minification-proof stamps of the values above.
 * Written out in full (not interpolated) so they survive as searchable strings
 * in the production bundle — the release-integrity check greps for them to
 * prove which web build is embedded in a native archive. Keep in sync; the
 * guard below fails the build if they ever drift.
 */
export const BUILD_STAMP = "TM_BUILD:APP_VERSION=1.82";
export const IOS_BUILD_STAMP = "TM_BUILD:IOS_BUILD=190";

if (BUILD_STAMP !== `TM_BUILD:APP_VERSION=${APP_VERSION}`) {
  throw new Error(`BUILD_STAMP (${BUILD_STAMP}) does not match APP_VERSION (${APP_VERSION})`);
}
if (IOS_BUILD_STAMP !== `TM_BUILD:IOS_BUILD=${IOS_BUILD}`) {
  throw new Error(`IOS_BUILD_STAMP (${IOS_BUILD_STAMP}) does not match IOS_BUILD (${IOS_BUILD})`);
}
